import React from "react"
import Button from "components/Button"
import ModalButtons from "components/ModalButtons"
import LabelValue from "components/LabelValue"
import { dipRequest } from "data/dip/api"
import withForm from "hoc/withForm"
import { P } from "styledComponents/Typography"
import withModal from "hoc/withModal"
import Textfield from "inputs/Textfield"
import Filepicker from "inputs/Filepicker"
import { stringRequired } from "validators/string"
import * as R from "ramda"

const SendReportToTaUnknownModal = ({ close, report, taxAccount, isSubmitting }) => (
  <>
    <P mb={20}>
      Tax authority account is not registered. Please conntact the site admin,
      if you want to register the account. You can still submit the report
      without account registration, but a valid certificate must be provided.
    </P>
    <LabelValue mb={20} label="Filing entity name" value={report.entityName} />
    <LabelValue mb={20} label="Filing entity ID" value={taxAccount.elster ?? taxAccount.bop ?? report.entityId} />
    <LabelValue mb={20} label="Account type" value={taxAccount.elster ? "Elster" : taxAccount.bop ? "BOP" : "N/A"} />
    <Filepicker
      name="certificateBlob"
      label="Client Certificate"
      sublabel="in PEM format"
      accept={[".pem"]}
      required
      upload={dipRequest.uploadCertificate}
      noEmptyError
      singleFile
    />
    <Filepicker
      name="privateKeyBlob"
      label="Private Key"
      sublabel="in PEM format"
      accept={[".pem"]}
      required
      upload={dipRequest.uploadPrivateKey}
      noEmptyError
      singleFile
    />
    <Textfield required width={130} name="pin" label="PIN" type="password" />
    <ModalButtons>
      <Button secondary type="button" onClick={close} text="Cancel" disabled={isSubmitting} />
      <Button danger type="submit" text="Send report to tax authority" disabled={isSubmitting} />
    </ModalButtons>
  </>
)

export default R.compose(
  withModal(R.always("Send report to tax authority")),
  withForm({
    schema: R.always({
      pin: stringRequired,
      certificateBlob: stringRequired,
      privateKeyBlob: stringRequired,
    }),
    onSubmit: p => v =>
      dipRequest.submitReportUnknown(p.reportId, {
        pin: v.pin,
        certificateBlob: R.path(["certificateBlob", "blobName"], v),
        privateKeyBlob: R.path(["privateKeyBlob", "blobName"], v),
      }),
    onSuccess: p => () => {
      p.close()
      p.refetch()
    },
    successText: () => R.always("Report successfully sent."),
    onError: (_, onChange) => () => {
      onChange("certificateBlob")(null)
      onChange("privateKeyBlob")(null)
    },
  }),
)(SendReportToTaUnknownModal)
